import type { IconSvgObject } from './types';

const AArrowDownIcon: IconSvgObject = [
  ["path", { d: "M2 18L6.32444 6.46816C6.43004 6.18656 6.69925 6 7 6C7.30075 6 7.56996 6.18656 7.67556 6.46816L12 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 14H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 13L18 17L22 13M18 16.5V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AArrowDownIcon;
